import { module } from "angular";

import type { Observable } from "rxjs";

import type { IHttpService } from "App/Modules/Services";

import type { ICountry, IResponse } from "App/Modules/Models";

import type { ICountriesRepository } from "./ICountriesRepository";

export default class CountriesRepository implements ICountriesRepository {
    public static $inject: string[] = ["mmHttpService"];

    constructor(private readonly httpService: IHttpService) {}

    public getAllCountries(): Observable<IResponse<ICountry[]>> {
        return this.httpService.get<ICountry[]>("countries");
    }
}

module("mmRepositories").service("irCountriesRepository", CountriesRepository);
